import { LazyQueryExecFunction } from '@apollo/client/react';
import {
  Intervention,
  InterventionFilterInputObject,
  InterventionScopeNameEnum,
  InterventionsSearchListQuery,
  InterventionsSearchListQueryVariables,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<
  InterventionsSearchListQuery,
  InterventionsSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
  scopeName: InterventionScopeNameEnum = InterventionScopeNameEnum.Opened,
) => {
  const options: { variables: InterventionsSearchListQueryVariables } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      scopeName,
      sorts: { createdAt: SortDirectionEnum.Desc },
    },
  };
  const filters: InterventionFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, defaultSearchListSchema));
  }
  if (filters.length) {
    options.variables.filters = filters;
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: Intervention) => ({
      value: dataItem.id,
      label: dataItem.code
        ? `${dataItem.code} — ${dataItem.name}`
        : dataItem.name,
    }),
    searchQuery,
  );
};

export const getInterventionsLoadOptions =
  (fetchLazyQuery: FetchLazyQuery, scopeName?: InterventionScopeNameEnum) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(searchQuery, fetchLazyQuery, params?.page || 1, scopeName);
